import "slick-carousel"

export default {
	init() {
		var sponsors_slider = $(".sponsor-card__slider:not(.slick-initialized)")

		if (sponsors_slider.length > 0) {
			sponsors_slider.slick({
				dots: true,
				arrows: false,
				autoplay: true,
				autoplaySpeed: 4500,
			})
		}
		
	}
}